import { useShopGetRecentlyViewedProducts } from '@frontend/libs/hooks/useShop'
import { __ } from '@wordpress/i18n'

import ProductSlider from '../product-slider/ProductSlider'
import ProductSliderLoader from '../product-slider/ProductSliderLoader'

export function RecentlyViewedProductSlider() {
  const { data, isLoading } = useShopGetRecentlyViewedProducts()

  if (isLoading) {
    return <ProductSliderLoader />
  }

  const products = (data?.success && data.data) || []

  if (products?.length === 0) {
    return <></>
  }

  return (
    <section className="my-16 grid grid-cols-1 overflow-hidden">
      <ProductSlider
        products={products}
        title={__('Recently view', 'asavagroup')}
      />
    </section>
  )
}

export default RecentlyViewedProductSlider
